import { makeAutoObservable } from "mobx";
import { appStore, printifyRequest } from "./AppMobx";
import { logDebug } from "../LocalLogger";
import { IProductCreation } from "../Pages/PreviewPage";

class PrintifyService {
	async init() {}

	async createDummyProductAndFetchPrices(providerId: number, blueprintId: number, imageId: string) {
		const retData = await printifyRequest("createDummyProductAndFetchPrices", {
			providerId,
			blueprintId,
			imageId,
		});
		return retData;
	}

	async createProductFromPayload(_productCreation: IProductCreation, dummy: boolean = false) {
		const product = await printifyRequest("createProductFromPayload", {
			payload: _productCreation,
			dummy,
		});
		return product;
	}

	uploadImage = async (imagePath: string, imageBase64: string) => {
		logDebug(`uploadImage => ${imagePath}`);
		const r = await printifyRequest("uploadImage", { imagePath, imageBase64 });
		await appStore.refreshImages();
		return r;
		// const rg = await req(`${this.base}/uploads.json`, { method: "GET" }, this.auth);
		// if (!rg.ok) await die(rg);
		// const listData = await rg.json();
		// if (listData?.data?.length && listData.data.find((i: any) => i.file_name === basename(pngPath))) {
		// 	const { id } = listData.data[0];
		// 	return id as string;
		// }
		// logDebug(`listData => ${JSON.stringify(listData)}`);
		// const body = JSON.stringify({
		// 	file_name: basename(pngPath),
		// 	contents: pngBase64,
		// });
		// const r = await req(`${this.base}/uploads/images.json`, { method: "POST", body }, this.auth);
		// if (!r.ok) await die(r);
		// const { id } = await r.json();
		// logDebug(`uploaded => ${id}`);
		// return id as string;
	};

	async findBlueprint(titleLike: string) {
		const r = await printifyRequest("findBlueprint", { titleLike });
		// logDebug(`findBlueprint => ${JSON.stringify(r)}`);
		return r;
	}

	findProviderAndVariants = async (blueprint: number) => {
		// const r1 = await req(`${this.base}/catalog/blueprints/${blueprint}/print_providers.json`, {}, this.auth);
		// if (!r1.ok) await die(r1);
		// const provider = first<any>(await r1.json()).id as number;
		// const r2 = await req(`${this.base}/catalog/blueprints/${blueprint}/print_providers/${provider}/variants.json`, {}, this.auth);
		// if (!r2.ok) await die(r2);
		// const data = await r2.json();
		// const variants = data.variants.map((v: any) => ({ id: v.id, price: 1500 })); // $15.00
		// return { provider, variants };
	};
	dummy() {
		// This is a dummy method to ensure the class is not empty
		// and can be extended in the future if needed.
		logDebug("Dummy method called");
	}
}

const printifyService = new PrintifyService();

export default printifyService;
